import { compose } from "ramda";

import { withBuyContextProvider } from "./BuyContext";
import { withLightboxContextProvider } from "./lightboxContext";
import { withQRContextProvider } from "./qrModalContext";

const withAllSDK = (component) =>
	compose(
		withLightboxContextProvider,
		withBuyContextProvider,
		withQRContextProvider,
	)(component);

const withAllSDKmarketingSite = (component) =>
	compose(withLightboxContextProvider, withQRContextProvider)(component);

export { withAllSDKmarketingSite };
export { withAllSDK };
